const Phones = ["+381 11 785 4852", "+381 11 785 4851"];

export default Phones;
